let g_devtricker_socialLogin_originalButtonValuesInnerHTML = [];

function devtricker_process_socialLogin(loginType) {

    let button = devtricker_dom_get_loginButton(loginType.buttonLoginId);

    devtricker_dom_set_changeContinueWithLoginSocialButtonToLoading(button);

    let state = {
        returnUrl: window.location.href,
        csrfToken: Math.random().toString(36).substring(2, 15),
        auth_method: loginType.authMethod
    };

    let stateEncoded = btoa(JSON.stringify(state));

    let url = `${loginType.baseUrl}client_id=${encodeURIComponent(loginType.clientId)}&redirect_uri=${encodeURIComponent(loginType.redirectUri)}&scope=${encodeURIComponent(loginType.scope)}&state=${encodeURIComponent(stateEncoded)}`;

    // url += '&prompt=consent';

    window.location.href = url;
}

function devtricker_process_saveSocialLoginOriginalButtonInnerHTML() {
    const buttons = document.querySelectorAll('.social-login-button');

    buttons.forEach(button => {
        g_devtricker_socialLogin_originalButtonValuesInnerHTML[button.id] = button.innerHTML;
    });
}